export const SOLD_SUBSCRIPTION_PAYMENT_STATUS_INFO = {
    FIRST_PAYMENT: 'first payment',
};
